import { render, staticRenderFns } from "./PhraseVolumeTrashCell.vue?vue&type=template&id=5c433de7&scoped=true"
import script from "./PhraseVolumeTrashCell.vue?vue&type=script&lang=js"
export * from "./PhraseVolumeTrashCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c433de7",
  null
  
)

export default component.exports